module.exports = __webpack_public_path__ + "img/minus.bcb6ef52.svg";